// Module
var code = "<cs-get-started cs-entity-type=\"server\" class=\"cs-flex-column-no-overflow\"> <react-servers-grid class=\"cs-flex-column-no-overflow\"></react-servers-grid> </cs-get-started>";
// Exports
var _module_exports =code;;
var path = '/views/servers/servers.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;